/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/pay_from'
export default icon
